/**
 * CardText — token templating for narrative cards.
 *
 * Replaces `[Callsign]` and `{playerName}` placeholders in card body
 * strings with the player's entered name (NameEntryScene → registry).
 * Falls back to "Captain" when no name is set so the copy still reads.
 *
 * Stage outro tokens `{bags}` and `{creature}` continue to be substituted
 * by StageClearScene; this helper only owns the player-name swap.
 */
import Phaser from 'phaser';

const FALLBACK_NAME = 'Captain';

export function getCallsign(scene: Phaser.Scene): string {
  const raw = scene.registry.get('playerName');
  const name = typeof raw === 'string' ? raw.trim() : '';
  return name || FALLBACK_NAME;
}

export function templateCardText(scene: Phaser.Scene, text: string | undefined): string {
  if (!text) return '';
  const name = getCallsign(scene);
  return text
    .replace(/\[Callsign\]/g, name)
    .replace(/\{playerName\}/g, name)
    .replace(/\{callsign\}/g, name);
}
